import { useCallback, useEffect } from 'react';
import {
  APP_TYPE,
  clearCfaDivisions,
  clearExtraDetails,
  clearSelectedCfas,
  clearSelectedItemIds,
  dispatch,
  getAppType,
  updateCurrentCustomerLocation,
  updatePeriodicBeatPlanInfo,
  updateRecordData,
  updateZoaiCustomerFlowState,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { useNavigate } from 'react-router-dom';
import { FIELD_OPS_ROUTES, SELLER_WEBAPP_ROUTES } from '../../constants';

export const useResetFlow = (navigateTo?: string) => {
  const navigate = useNavigate();
  const appType = useAppSelector(getAppType);

  const resetState = useCallback(() => {
    dispatch(updateRecordData(undefined));
    dispatch(updateCurrentCustomerLocation(undefined));
    dispatch(clearCfaDivisions());
    dispatch(clearSelectedCfas());
    dispatch(clearSelectedItemIds());
    dispatch(updatePeriodicBeatPlanInfo(undefined));
    dispatch(updateZoaiCustomerFlowState({ state: false, channel: '' }));
  }, []);

  const handleBack = useCallback(() => {
    resetState();
    if (appType === APP_TYPE.FIELDS_OPS) {
      navigate(navigateTo ?? FIELD_OPS_ROUTES.VIEW_CUSTOMER_LIST);
      return;
    } else if (appType === APP_TYPE.SELLER_HUB) {
      navigate(navigateTo ?? SELLER_WEBAPP_ROUTES.MANAGE_CUSTOMERS_LIST);
      return;
    } else {
      return;
    }
  }, [appType, navigate, navigateTo, resetState]);

  useEffect(() => {
    const handleBrowserBack = () => resetState();

    window.addEventListener('popstate', handleBrowserBack);
    return () => {
      window.removeEventListener('popstate', handleBrowserBack);
    };
  }, [resetState]);

  return {
    handleBack,
  };
};
